import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SsoRedirectionComponent } from './core/sso-redirection/sso-redirection.component';
import { LandingComponent } from './core/landing/landing.component';
import { authGuard } from './core/guards/auth.guard';
import { Roles } from './shared/constants/roles';
import { Privileges } from './shared/constants/privileges';
import { autoLoginGuard } from './core/guards/auto-login.guard';
import { InboundSsoComponent } from './core/inbound-sso/inbound-sso.component';
import { inboundSsoGuard } from './core/guards/inbound-sso.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'landing', canActivate: [autoLoginGuard], component: LandingComponent },
  {
    path: 'benefits',
    data: { requiredAccess: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.CUSTOM, Privileges.CUSTOM_ADD] },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/benefits/benefits.module').then(m => m.BenefitsModule)
  },
  {
    path: 'ccm',
    data: {
      requiredAccess: [Roles.SUPER_ADMIN, Privileges.CCM_MEMBER, Privileges.CCM_PROSPECT, Privileges.CCM_PROVIDER, Privileges.CCM_PRODUCER, Privileges.CCM_EMPLOYER]
    },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/ccm/ccm.module').then(m => m.CcmModule)
  },
  {
    path: 'employer',
    data: {
      requiredAccess: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS, Privileges.CWS_BUS, Privileges.CWS_TECH, Privileges.EMPLOYER_SURVEY_REPORT]
    },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/employer/employer.module').then(m => m.EmployerModule)
  },
  {
    path: 'login',
    canActivate: [autoLoginGuard],
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'manage-csa-users',
    data: {
      requiredAccess: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER]
    },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/manage-csa-users/manage-csa-users.module').then(m => m.ManageCsaUsersModule)
  },
  {
    path: 'manage-oep',
    data: {
      requiredAccess: [Roles.SUPER_ADMIN]
    },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/manage-oep/manage-oep.module').then(m => m.ManageOepModule)
  },
  {
    path: 'member',
    data: {
      requiredAccess: [Roles.SUPER_ADMIN, Privileges.MEMBERS, Privileges.MEMBER_RESTRICT, Privileges.MANAGE_SHIFTED_MEMBERS]
    },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/member/member.module').then(m => m.MemberModule)
  },
  {
    path: 'my-profile',
    data: { requiredAccess: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Roles.USER_MANAGER] },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/my-profile/my-profile.module').then(m => m.MyProfileModule)
  },
  {
    path: 'producer',
    data: {
      requiredAccess: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE]
    },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/producer/producer.module').then(m => m.ProducerModule)
  },
  {
    path: 'prospect',
    data: {
      requiredAccess: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT]
    },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/prospect/prospect.module').then(m => m.ProspectModule)
  },
  {
    path: 'provider',
    data: {
      requiredAccess: [Roles.SUPER_ADMIN, Privileges.PROVIDERS, Privileges.PROVIDER_REPORTS]
    },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/provider/provider.module').then(m => m.ProviderModule)
  },
  {
    path: 'self-funded',
    data: {
      requiredAccess: [Roles.SUPER_ADMIN, Privileges.TPA_CREATEUSER, Privileges.TPA_SEARCH, Privileges.TPA_EXTERNAL_NOTIFICATIONS, Privileges.TPA_USER_DASHBOARD]
    },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/self-funded/self-funded.module').then(m => m.SelfFundedModule)
  },
  {
    path: 'home',
    data: { requiredAccess: [] },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'help',
    data: { requiredAccess: [] },
    canActivate: [authGuard],
    loadChildren: () => import('./modules/help/help.module').then(m => m.HelpModule),
    // title: 'Help with Customer Service Administration'
  },
  {
    path: 'sso-redirection',
    data: { requiredAccess: [] },
    canActivate: [authGuard],
    component: SsoRedirectionComponent
  },
  {
    path: 'sales-force-sso',
    canActivate: [inboundSsoGuard],
    component: InboundSsoComponent
  },
  {
    path: 'inbound-sso',
    canActivate: [inboundSsoGuard],
    component: InboundSsoComponent
  },
  {
    path: 'adlogin',
    canActivate: [inboundSsoGuard],
    component: InboundSsoComponent
  },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
